const home = {
  title: 'Valide seu documento',
  validate_with_document: {
    title: 'Validar documento a partir de um PDF',
    description: 'Tenho um documento assinado pela Clicksign.',
    button: 'Validar com documento',
  },
  generate_password: {
    title: 'Gerar senha para validação a partir de um PDF',
    description: 'Preciso gerar uma senha para que seja validado por terceiros.',
    button: 'Gerar senha',
  },
  validate_with_password: {
    title: 'Validar documento a partir de Senha',
    description: 'Tenho a senha de acesso ao documento eletrônico.',
    button: 'Validar com senha',
  },
  renew_certificate: {
    title: 'Renove o certificado',
    subtitle: 'Utilize essa opção para renovar os certificados já expirados.',
    validate_with_document: {
      title: 'Renovar certificado do documento',
      description: 'Tenho o documento assinado e quero atualizar o certificado Clicksign.',
      button: 'Validar com documento',
    },
  },
  document_p7s: {
    title: 'Baixar o documento assinado no formato p7s',
    subtitle: 'Utilize essa opção para baixar os documentos já assinados.',
    card: {
      title: 'Baixar documento em p7s',
      description: 'Tenho o documento assinado e quero baixar ele no formato p7s.',
      button: 'Baixar documento',
    },
  },
};

export default home;
